import {useEffect} from "react"
import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"
import {InvalidCodeImage} from "@indebted/assets"
import {TextToHTML} from "@indebted/components/TextToHTML"

function SecureCodeNotFound({secureCode}: {secureCode: string}) {
	const {t} = useTranslation()

	useEffect(() => {
		console.error("Secure code not found", secureCode)
	}, [secureCode])

	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.not_found.title")}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML align="center" text={t("customer_get.not_found.help")} />
			</Grid>

			<Grid>
				<TextToHTML align="center" text={t("customer_get.not_found.message")} />
			</Grid>

			<GridImage>
				<InvalidCodeImage />
			</GridImage>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {SecureCodeNotFound}
